import { types } from 'mobx-state-tree'
import { my_bookings__get } from '../api/experiences'
import group_experiences from '../api/group_experiences'

const MyBookingsStore = types.model({
  loaded: types.optional(types.boolean, false),
  data: types.optional(types.frozen, [])
}).views(
  /**
   * @param {Object} self
   * @returns {Object}
   */
  self => ({
    get grouped_bookings () {
      console.log('MyBookingsStore - grouped_bookings - self.loaded:', self.loaded)
      // if (!self.loaded) {
      //   return false
      // }
      let objects = self.data
      return group_experiences({objects, computed_date_format: 'event.date'})
    }
  })
).actions(
  /**
   * @param {Object} self
   * @returns {Object}
   */
  self => ({
    get (token) {
      self.loaded = false
      my_bookings__get(token).then(
        self.fetch
      )
    },
    fetch (data) {
      self.data = data
      self.loaded = true
      console.log('MyBookingsStore - fetch - data:', data)
      console.log('MyBookingsStore - fetch - self.loaded:', self.loaded)
    },
    clean () {
      self.data = false
      self.loaded = false
    },
    is_booked(experience_id, event_id) {
      const data = self.data

      console.log('MyBookingsStore - is_booked - data:', data)
      console.log('MyBookingsStore - is_booked - experience_id:', experience_id)
      console.log('MyBookingsStore - is_booked - event_id:', event_id)

      if ( !experience_id
        || !event_id
      ) {
        return 'loading'
      }

      const result = data.find(obj => obj.experience_id === experience_id && obj.event_id === event_id)
      console.log('MyBookingsStore - is_booked - result:', result)

      return typeof result !== 'undefined'
    }
  })
)

export default MyBookingsStore



// WEBPACK FOOTER //
// ./src/stores/MyBookingsStore.js